<!-- =========================================================================================
    File Name: VxTour.vue
    Description: Tour Component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
        <div  class="vx-row items-center mb-2">
            <v-select class="w-full  sm:w-1/3 mr-2 " style="width:200px"
                name='name'
                label="name"
                placeholder="스토어"
                v-model="store"
                :options="storeList"
                :reduce="languageOption => languageOption.id"
                :clearable="false"
                />
                <v-select class=" w-full sm:w-1/3 mr-2 " style="width:200px"
                name='name'
                label="name"
                placeholder="언어"
                v-model="lang"
                :options="languageOption"
                :reduce="languageOption => languageOption.code"
                :clearable="false"
                />
        </div>
        <div class="vx-row items-center mb-2">
            <vs-input v-model="name" class="w-full sm:w-2/3" :placeholder="title"/>
            <vs-button class="ml-3 small" style="vertical-align:top; height:30px;" color="success" @click="add" type="gradient">추가</vs-button>
        </div>
        
        <!-- <ul >
            <li class="vx-row items-center mb-2" v-for="(item, key) in langList">
                <v-select class="mr-2" style="width:130px"
                    name='name'
                    label="name"
                    placeholder="앨범명(번역)" 
                    v-model="key"
                    :options="languageOption"
                    :reduce="languageOption => languageOption.code" 
                    :clearable="false" 
                    disabled/>
                <vs-input @input="update(key, $event)" :value="langList[key]" class="" placeholder="앨범명(번역)"/>
                <vs-button class="ml-3 small" style="vertical-align:top; height:30px;" color="danger" @click="del" type="gradient">삭제</vs-button>
            </li>
        </ul> -->
        <vs-table :data="[]" class="mt-4 w-full" >
            <template slot="thead">
                <vs-th style="width:150px">스토어</vs-th>
                <vs-th>언어 / {{title ? title : '이름'}}</vs-th>
            </template>
            <template v-for="(store, key) in langList">
                <vs-tr>
                    <vs-td width="1">
                        {{findStore(key)}}
                    </vs-td>
                    <vs-td >
                        <!-- {{ data[indextr].name }} -->
                        
                       <div v-for="store, lang in store"  >
                        
                       
                            <div class="vx-row " style="flex-wrap: nowrap; ">    
                                <vs-input @input="update(key,lang, $event)" :value="langList[key][lang]" style="margin :0 30px 0 0;" class="w-full " placeholder="앨범명(번역)"/>
                                <vs-button class="ml-3 small" style="vertical-align:top; height:30px; width:100px; margin :0 30px 0 0.75rem;" color="danger" @click="del(key)" type="gradient">삭제</vs-button>
                            </div>
                       </div>
                    </vs-td>
                    
                </vs-tr>
            </template>
        </vs-table>
        
    </div>
</template>

<script>

import optionData from '@/optionData/data'

export default{
    name: 'dj-lang',
    props: ['langList','title'],
    data () {
        return{
            storeList: [],
            store : null,
            name : null,
            lang : null,
            languageOption : optionData.language,
        }
    },
    watch: {
        'langList'(){
            
        }
    },
    created () {
        this.getContract()
    },
    methods:{
        update(store,lang,val){
            this.langList[store][lang] = val
            this.$forceUpdate()
            this.$emit('changeUpdate', this.langList)
        },
        findStore(id){
            for(let i in this.storeList){
                this.storeList
                if(this.storeList[i].id == id ){
                    return this.storeList[i].name
                    break;
                }
            }
        },
        add(){
            console.log(this.store,this.lang,this.name)
            if(this.store && this.lang && this.name){
                if(typeof this.langList[String(this.store)] === 'undefined' ){
                    this.langList[String(this.store)] = {}
                    if(typeof this.langList[String(this.store)][this.lang] === 'undefined' ){
                        this.langList[String(this.store)][this.lang] = this.name
                        this.store = null
                        this.lang = null    
                        this.name = null    
                    }else{
                        this.noti('이미 등록된 언어 입니다.')    
                    }
                    
                }else{
                    if(typeof this.langList[String(this.store)][this.lang] === 'undefined' ){
                        this.langList[String(this.store)][this.lang] = this.name
                        this.store = null
                        this.lang = null    
                        this.name = null    
                    }else{
                        this.noti('이미 등록된 언어 입니다.')    
                    }
                }
                
            }else{
                this.noti('스토어,언어,앨범명을 모두 입력하세요.')
            } 
            this.$forceUpdate()
        },
        del(data){
            delete this.langList[data]
            this.$forceUpdate()
            this.$emit('changeUpdate', this.langList)
        },
        getContract(){
          let payload = {
            sort : 'created_at',
            sortorder: 'desc',
            page: 0 ,
            limit: 50,
          }
            this.$store.dispatch('GET_DDEX_CONTRACT', payload)
            .then(result =>{
                this.loadingHide()
                this.storeList  = result.items // 권리자 목록
                
                //페이지 수
            }).catch(error=>{
                this.loadingHide()
                const status = error.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                    this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
    }
}
</script>

<style lang="scss">

</style>
